module.exports = __webpack_public_path__ + "sunsemweb/img/s.3585df0e.png";